import axios from '@/plugins/axios'

export function getInfo() {
    return axios({
        url: 'huangli/info',
        method: 'GET'
    })
}